module.exports = __webpack_public_path__ + "img/sepa_logo.391e79a0.png";